import React from 'react'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom';
import qs from 'qs';
import buscarEncomenda from '../../actions/encomenda/buscarEncomenda';
import { formatarReal } from '../../util/numberUtil';
import { SeguroEncomenda } from './SeguroEncomenda';
import { situacaoTransmissaoCteOs, tipoImpressaoCupom } from '../../util/constantsUtil';
import ModalImpressaoCupomEncomenda from './ModalImpressaoCupomEncomenda';
import ReciboCupomEncomenda from './ReciboCupomEncomenda';

export class ReciboEncomenda extends React.Component {
  constructor(props) {
    super(props);    
    
    this.state = {
      referencias: null,
      componentRef:  React.createRef(),
      pagina: null,
      referenciasCheckeds: [],
      refComponent: React.createRef(),
      isOpenModal: false,
      tipoImpressaoCupom: tipoImpressaoCupom.normal,
    }
  }

  imprimir() {
    window.print();
  }

  habilitarDesabilitarReciboCupomEncomenda(valor) {
    this.setState({ isOpenModal: valor })
  }

  setTipoImpressaoCupom(tipo) {    
    this.setState({ tipoImpressaoCupom: tipo })
  }

  componentDidMount() {
    if (this.props.empresaSelecionada.id) {
      const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
      if (parametros.encomenda) {
        this.props.buscarEncomenda(parametros.encomenda, this.props.empresaSelecionada.id)
          .then(({payload})=> {
            if (payload.status == 200) {              
              this.getReferencias(payload.data);
            }
          });
          this.setState({pagina: window})
      }
    } else {
      this.props.history.push('/painel-encomendas')
    }
  }

  getReferencias(encomenda) {
    const ref = new Map();
      ref.set('REMETENTE', {
          id: 'remetente',
          nome: `Remetente: ${encomenda.remetente.nome}`,
          nomeParaImpressao: encomenda.remetente.nome,          
          referencia: React.createRef()
      })
      ref.set('DESTINATARIO', {
        id: 'destinatario',
        nome: `Destinatário: ${encomenda.destinatario.nome}`,
        nomeParaImpressao: encomenda.destinatario.nome,        
        referencia: React.createRef()
      })
      ref.set('AGENCIA', {
        id: 'agencia',
        nome: 'via agência',
        nomeParaImpressao: 'via agência',        
        referencia: React.createRef()
      })
      ref.set('ENTREGA', {
        id: 'entrega',
        nome: 'via entrega',
        nomeParaImpressao: 'via entrega',        
        referencia: React.createRef()
      })
      ref.set('RECIBO_DE_ENTREGA', {
        id: 'recibo_de_entrega',
        nome: 'recibo de entrega',
        nomeParaImpressao: 'recibo de entrega',        
        referencia: React.createRef()
      })
      
      this.setState({referencias: ref, referenciasCheckeds: [...ref.keys()].map(it => ({
        key: it,
        checked: false
      })) 
    })
  }

  marcarReferencia(key) {    
    const referenciasCheckeds = Object.assign([], this.state.referenciasCheckeds);    
    if (referenciasCheckeds.filter(it => it.key === key)[0].checked) {      
      referenciasCheckeds.forEach(it => {
        if (it.key === key) {
          it.checked = false                    
        }
      })
    } else {      
      referenciasCheckeds.forEach(it => {
        if (it.key === key) {
          it.checked = true
        }
      })
    }
    this.setState({ referenciasCheckeds })
  }

  limparMarcacaoReferenciasCheckeds() {
    const referenciasCheckeds = [...this.state.referenciasCheckeds];
    referenciasCheckeds.forEach(it => {
      it.checked = false
    })
    this.setState({ referenciasCheckeds })
  }

  exibirRemetenteDestinatario(endereco, pessoa) {
    if (endereco && pessoa) {
      return <address>
        <strong>Nome: </strong><span className='text-break'>{pessoa.nome}</span><br />
        <strong>E-mail: </strong><span className='text-break'>{pessoa.email}</span><br />
        <strong>Telefone: </strong><span className='text-break'>{pessoa.telefone}</span><br />
        <span className='text-break'>{`${endereco.logradouro}, ${endereco.numero ? endereco.numero : 'S/N'}${endereco.complemento ? `, ${endereco.complemento}` : ''}`}</span><br />
        <span className='text-break'>{`${endereco.bairro} - ${endereco.localidade} - ${endereco.uf}`}</span><br />
        CEP: <span>{endereco.cep}</span>
      </address>
    }
  }

  exibirFormasPagamento() {
    return this.props.encomenda.formasPagamento.map(it => <div key={it.idFormaPagamento}><strong className='mr-2'>{it.tipo}:</strong>{formatarReal(it.valor.toString())}<br />
      {it.quantidadeParcelas > 1 ? <div><strong>Parcelas: </strong>{it.quantidadeParcelas}x<br /></div> : ''}
    </div>)
  }

  exibirNotasFiscais() {
    if (this.props.encomenda.notasFiscais && this.props.encomenda.notasFiscais.length) {
      return <React.Fragment>
        <table className="table table-sm table-bordered text-center">
          <thead>
            <tr>
              <td colSpan={4} className='text-center'>
                <strong>Notas Fiscais</strong>
              </td>
            </tr>
            <tr>
              <th scope="col">Número do documento</th>
              <th scope="col">Valor</th>
              <th scope="col">Volume</th>
              <th scope="col">Peso (KG)</th>
            </tr>
          </thead>
          <tbody>
            {this.props.encomenda.notasFiscais.map(notaFiscal => <tr key={notaFiscal.numeroDocumento}>
              <td>{notaFiscal.numeroDocumento}</td>
              <td>{formatarReal(notaFiscal.valor)}</td>
              <td>{notaFiscal.quantidade}</td>
              <td>{notaFiscal.peso}</td>
            </tr>)
            }
          </tbody>
          <tfoot>
            <tr>
              <td><strong>Totais</strong></td>
              <td>{formatarReal(this.props.encomenda.totalValorNotaFiscal)}</td>
              <td>{this.props.encomenda.totalQuantidadeNotaFiscal}</td>
              <td>{this.props.encomenda.totalPesoNotaFiscal}</td>
            </tr>
          </tfoot>
        </table>
      </React.Fragment>
    }
  }

  exibirReciboEntrega() {
    return <React.Fragment>
      <div className="kloai card">
        <div className="card-header text-center" style={{ height: 36 }}>
          RECIBO DE ENTREGA
        </div>
        <div className='card-body' style={{ height: 115 }}>
          <div className='row justify-content-around'>
            <div className="col-md-10">
              <span>Declaro haver recebido as mercadorias das notas fiscais acima.</span>
            </div>
            <div className="col-md-2 text-right">
              <span>OS: {this.props.encomenda.idPedido}</span>
            </div>
          </div>
          <div className='row justify-content-around mt-2'>
            <div className="col-md-8">
              <span>Assinatura: </span>
              <div style={{
                width: '90%',
                borderBottom: '1px solid black',
                marginLeft: '74px'
              }}></div>
            </div>
            <div className="col-md-4">
              <span>RG:</span>
              <div style={{
                width: '90%',
                borderBottom: '1px solid black',
                marginLeft: '40px'
              }}></div>
            </div>
          </div>
          <div className='row justify-content-around mt-2'>
            <div className="col-md-8">
              <span>Nome:</span>
              <div style={{
                width: '96%',
                borderBottom: '1px solid black',
                marginLeft: '44px'
              }}></div>
            </div>
            <div className="col-md-4">
              <span>CPF:</span>
              <div style={{
                width: '90%',
                borderBottom: '1px solid black',
                marginLeft: '40px'
              }}></div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  }

  exibirEtiquetas() {
    if (this.props.encomenda.volume) {
      return <React.Fragment>
        {[...Array(this.props.encomenda.volume)
          .keys()].map(it => (
            <React.Fragment key={`volume-encomenda${it}`}>
              <div className="card">
                <div className='card-body'>
                  <div className='row justify-content-around'>
                    <div className="col-md-8">
                      <h5><strong>Rota: </strong>{this.props.encomenda.rotaCidadeOrigem} à {this.props.encomenda.rotaCidadeDestino}</h5>
                      <h2>Destino:</h2>
                      <div><strong style={{ fontSize: 50 }}>{this.props.encomenda.cidadeDestino}</strong></div>
                    </div>
                    <div className="col-md-4 text-right">
                      <h5>Volume: {it + 1}/{this.props.encomenda.volume}</h5>
                      <h5>OS: {this.props.encomenda.idPedido}</h5>
                    </div>
                  </div>
                  <div className='row justify-content-around'>
                    <div className="col-md-12">
                      <h2>Destinatário:</h2>
                      <div><strong style={{ fontSize: 50 }}>{this.props.encomenda.destinatario.nome}</strong></div>
                    </div>
                  </div>
                </div>
              </div>
              {it + 1 !== this.props.encomenda.volume ? <hr className='mt-2' style={{ borderTop: '2px dashed' }} /> : ''}
            </React.Fragment>
          ))}
      </React.Fragment>
    }
  }

  exibirCupom(pagina, via) {
    return <React.Fragment>
      <div className='kloai mt-2' style={{ border: '1px solid' }}>
        <div className="invoice-title">
          <div className="row justify-content-around">
            <div className="col-md-3">
              <strong>{this.props.empresaSelecionada.nome}</strong>
              {this.props.empresaSelecionada.cnpj && <strong> - CNPJ: {this.props.empresaSelecionada.cnpj}</strong>}
            </div>
            <div className="col-md-3">
              <strong>Emissão: {this.props.encomenda.dataCriacao}</strong>
            </div>
            <div className="col-md-2">
              <strong>Via: {via}</strong>
            </div>
            <div className="col-md-2">
              <strong>OS número: {this.props.encomenda.idPedido}</strong>
            </div>
          </div>
          <hr />
          <div className="row justify-content-around">
            <div className="col-md-12">
            <strong className='ml-1'>Rota: </strong>{this.props.encomenda.rotaCidadeOrigem} à {this.props.encomenda.rotaCidadeDestino}
            </div>
          </div>
          <div className="row justify-content-around">
            <div className="col-md-6">
              <strong className='ml-1'>Origem:</strong><span className='ml-2'>{this.props.encomenda.cidadeOrigem} - {this.props.encomenda.dataHoraPartida}</span><br />
            </div>
            <div className="col-md-6">
              <strong>Destino:</strong><span className='ml-2'>{this.props.encomenda.cidadeDestino} - {this.props.encomenda.dataHoraChegada}</span><br />
            </div>
          </div>
        </div>
        <hr />
        <div className="row justify-content-around">
          <div className="col-md-3">
            <address className='ml-1'>
              <strong>Remetente:</strong><br />
              {this.exibirRemetenteDestinatario(this.props.encomenda.enderecoRemetente, this.props.encomenda.remetente)}
            </address>
          </div>
          <div className="col-md-3">
            <address>
              <strong>Destinatário:</strong><br />
              {this.exibirRemetenteDestinatario(this.props.encomenda.enderecoDestinatario, this.props.encomenda.destinatario)}
            </address>
          </div>
          <div className="col-md-3">
            <address>
              <strong>Formas de pagamento:</strong><br />
              {this.exibirFormasPagamento()}
              <strong className='mr-2'>Resp. pelo pagamento:</strong>
              Remetente<br />
              <strong className='mr-2'>Status pagamento:</strong>
              Pago<br />
              <SeguroEncomenda encomenda={this.props.encomenda} isRecibo={true} />
            </address>
          </div>
          <div className="col-md-3">
            <address>
              <strong className='mr-2'>Descrição Produto:</strong>
              {this.props.encomenda.descricaoProduto}<br />
              <strong className='mr-2'>Tipo de cálculo:</strong>
              {this.props.encomenda.descricaoTipoCalculo}<br />
              <strong className='mr-2'>Volumes:</strong>
              {this.props.encomenda.volume}<br />
            </address>
          </div>
        </div>
        {this.exibirNotasFiscais()}        
        <div className="row">
          <div className="col-md-12">
            <strong className='ml-1'>Mensagem de via Remetente: </strong>
            <span className="text-break">
              {this.props.encomenda.mensagemViaRemetente}
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <strong className='ml-1'>Observação: </strong>
            <span className="text-break">
              {this.props.encomenda.observacao}
            </span>
          </div>
        </div>
        <hr />
        <div className="row justify-content-around">
          <div className="col-md-3">
            <strong className='ml-2'>Agência: {this.props.encomenda.nomeAgencia ? this.props.encomenda.nomeAgencia : 'Não informado'}</strong>
          </div>
          <div className="col-md-3">
            <strong>Vendedor: {this.props.encomenda.nomeVendedor}</strong>
          </div>
          <div className="col-md-3">
            <strong>Data: {this.props.encomenda.dataCriacao}</strong>
          </div>
          <div className="col-md-3 text-right">
            <strong className='mr-1'>Página: {pagina}/3</strong>
          </div>
        </div>
      </div>
    </React.Fragment>
  }

  exibeBotaoImprimirNota() {
    if (this.props.encomenda.ultimoHistoricoEmissaoCte != null
        && this.props.encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.chave == situacaoTransmissaoCteOs.sucesso) {
        return true;
    }

    return false;
  }

  exibirBotoes() {
    return (
      <React.Fragment>
        <div className='row justify-content-md-center mt-2' id='printPageButton'>
          <Link className="ml-2" to="/painel-encomendas">
            <button className='btn btn-sm btn-laranja'>Concluir</button>
          </Link>          
          <a className="btn  btn-sm btn-laranja ml-2" data-toggle="modal"
            data-target="#modalImpressaoCupomEncomenda" onClick={() => this.habilitarDesabilitarReciboCupomEncomenda(true)}>
           <i className="material-icons mr-1" style={{
              fontSize: '18px',
              verticalAlign: 'middle'
            }}>
              &#xe8ad;
            </i>
            Imprimir
          </a>
          {this.exibeBotaoImprimirNota() && <a target="_BLANK" style={{ cursor: 'pointer' }} className="btn  btn-sm btn-laranja ml-2"
            onClick={() => {
              const url = `/nota-fiscal-cte?encomenda=${this.props.encomenda.id}`;
              this.props.history.push(url)
            }}>
            <i className="material-icons mr-1" style={{
              fontSize: '18px',
              verticalAlign: 'middle'
            }}>
              &#xe8ad;
            </i>
            Imprimir CT-e
          </a>}
        </div>
      </React.Fragment>)
  }

  apresentarReciboCupomTermica() {
    return this.state.isOpenModal && this.state.tipoImpressaoCupom == tipoImpressaoCupom.termica;
  }

  render() {
    if (this.props.encomenda) {
      return <React.Fragment>
        <div className="grid invoice">
          {this.exibirBotoes()}
          <div ref={this.state.componentRef} className="grid-body mt-4" id='cupom-encomenda' style={{ fontSize: 16, fontWeight: 'bold' }}>
            {this.exibirCupom(1, 'Remetente')}
            <hr style={{ borderTop: '2px dashed' }} />
            {this.exibirCupom(1, 'Agência')}
            <div className="pagebreak"></div>
            {this.exibirCupom(2, 'Destinatário')}
            <hr style={{ borderTop: '2px dashed' }} />
            {this.exibirCupom(2, 'Entrega')}
            <hr style={{ borderTop: '2px dashed' }} />
            {this.exibirReciboEntrega()}
            <div className="pagebreak"></div>
            {this.exibirEtiquetas()}
          </div>
          {this.exibirBotoes()}
        </div>
        {this.apresentarReciboCupomTermica() && <div ref={this.state.refComponent} className="printer-ticket ReciboCupomEncomenda">
            <ReciboCupomEncomenda referencias={this.state.referencias} encomenda={this.props.encomenda} empresaSelecionada={this.props.empresaSelecionada} />
        </div>}
        <ModalImpressaoCupomEncomenda 
          referencias={this.state.referencias} 
          referenciasCheckeds={this.state.referenciasCheckeds} 
          pagina={this.state.pagina}
          marcarReferencia={this.marcarReferencia.bind(this)} 
          limparMarcacaoReferenciasCheckeds={this.limparMarcacaoReferenciasCheckeds.bind(this)}
          refComponent={this.state.refComponent}
          isOpenModal={this.state.isOpenModal}
          tipo={this.state.tipoImpressaoCupom}
          setTipoImpressaoCupom={this.setTipoImpressaoCupom.bind(this)}
          habilitarDesabilitarReciboCupomEncomenda={this.habilitarDesabilitarReciboCupomEncomenda.bind(this)} />
      </React.Fragment>
    }
    return '';
  }
}


export const mapStateToProps = state => (
  {
    empresaSelecionada: state.empresaSelecionada,
    encomenda: state.encomenda
  });


export default withRouter(connect(mapStateToProps, { buscarEncomenda })(ReciboEncomenda));
